var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"blockText",class:( _obj = {
    'block-text': _vm.applyStyles,
    'block-text-fullwidth': _vm.fullWidth
  }, _obj[_vm.alignment] = true, _obj ),domProps:{"innerHTML":_vm._s(_vm.textData)}})}
var staticRenderFns = []

export { render, staticRenderFns }